import {createFeatureSelector, createSelector} from '@ngrx/store';
import {OrdersState} from './orders.state';
import {ordersFeatureKey} from './orders.reducer';

const ordersSelector = createFeatureSelector<OrdersState>(ordersFeatureKey);

export const selectOrder = createSelector(
  ordersSelector,
  state => state.order
);

export const selectOrders = createSelector(
  ordersSelector,
  state => state.orders
);

export const selectChannels = createSelector(
  ordersSelector,
  state => state.channels
);

export const selectAreOrdersLoading = createSelector(
  ordersSelector,
  state => state.orders.isLoading
);

export const selectSelectedTabIndex = createSelector(
  ordersSelector,
  state => state.selectedTabIndex
);

export const SELECT_OVERVIEW = createSelector(
  ordersSelector,
  state => state.overview
);

export const SELECT_OVERVIEW_IS_LOADING = createSelector(
  ordersSelector, state => state.overviewIsLoading
);


